/**
 * Package Explorer tab — feature-local types, factory, and reuse helper.
 *
 * The core tab type (`PackageExplorerTab`) and type guard live in
 * `../core/types/workspaceTypes.ts` so that the workspace core can statically
 * discriminate on `Tab.type`. This file holds the factory and lookup helper
 * that are specific to the feature.
 */

import type { PackageExplorerTab, PackageExplorerTabContent, Tab } from '../core/types/workspaceTypes';
import { isPackageExplorerTab } from '../core/types/workspaceTypes';

/** Default content factory for Package Explorer tabs */
export function createDefaultPackageExplorerContent(args: {
  connectionId: string;
  database: string;
}): PackageExplorerTabContent {
  return {
    connectionId: args.connectionId,
    database: args.database,
  };
}

/**
 * Find an existing Package Explorer tab bound to the same connection and
 * database. Returns `undefined` when no such tab exists.
 */
export function findExistingPackageExplorerTab(
  tabs: readonly Tab[],
  connectionId: string,
  database: string,
): PackageExplorerTab | undefined {
  for (const tab of tabs) {
    if (
      isPackageExplorerTab(tab) &&
      tab.content.connectionId === connectionId &&
      tab.content.database === database
    ) {
      return tab;
    }
  }
  return undefined;
}
